<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5402 5.42252L3.4502 5.42252C3.01253 5.42252 2.65738 5.77755 2.65738 6.21483C2.65738 6.65211 3.01253 7.00714 3.4502 7.00714L20.5402 7.00714C20.9779 7.00714 21.332 6.65211 21.332 6.21483C21.332 5.77755 20.9779 5.42252 20.5402 5.42252Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5402 11.204L3.4502 11.204C3.01253 11.204 2.65738 11.5591 2.65738 11.9964C2.65738 12.4336 3.01253 12.7887 3.4502 12.7887L20.5402 12.7887C20.9779 12.7887 21.332 12.4336 21.332 11.9964C21.332 11.5591 20.9779 11.204 20.5402 11.204Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5402 16.9856H3.4502C3.01253 16.9856 2.65738 17.3406 2.65738 17.7779C2.65738 18.2152 3.01253 18.5702 3.4502 18.5702L20.5402 18.5702C20.9779 18.5702 21.332 18.2152 21.332 17.7779C21.332 17.3406 20.9779 16.9856 20.5402 16.9856Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'UlMenu'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
